const isValidFile = file => file instanceof File;

export default isValidFile;
